import React, {ReactNode} from "react"
import {createPortal} from "react-dom"

const Portal: React.FC<{target: HTMLDivElement | null; children: ReactNode}> = ({
    target,
    children,
}) => {
    return target ? createPortal(children, target) : null
}

export const PortalBuilder: (target: HTMLDivElement | null) => React.FC<{children: ReactNode}> =
    (target) =>
    ({children}) =>
        <Portal target={target}>{children}</Portal>
